import { flexColumn, flexRow, media } from '@anm/styles/helpers';
import styled from 'styled-components';

const mobileButton = media.phone`
  width: 147px;
  min-width: unset;
`;

export const ButtonsRow = styled.div`
  ${flexRow};
  justify-content: space-between;

  & > div,
  button {
    width: 200px;
    ${mobileButton}
  }
`;

export const ButtonsContainer = styled.div`
  ${flexColumn};
`;

export const Hint = styled.div`
  width: 200px;
  font-size: 14px;
  line-height: 18px;
  margin-bottom: 8px;
  color: var(--gray_900);
`;
